/* eslint-disable prefer-destructuring */
import DialogConditionDTO from './DialogConditionDTO';
import DialogOutputDTO, { MAP_OUTPUT_FROM_WATSON } from './DialogOutputDTO';

export default class DialogSlotsDTO {
  constructor(slot = null) {
    if (slot) {
      if (slot.id) {
        this.id = slot.id;
      }
      if (slot.context) {
        this.condition = DialogConditionDTO.buildList(Object.values(slot.context)[0])[0];
        this.contextVariable = Object.keys(slot.context)[0];
      } else {
        this.condition = new DialogConditionDTO();
        this.condition.relationalOperator = null;
        this.contextVariable = '';
      }
      if (slot.outputs) {
        this.output = slot.outputs[0];
      } else {
        this.output = new DialogOutputDTO({ type: MAP_OUTPUT_FROM_WATSON.TEXT }, true);
      }
    } else {
      this.condition = new DialogConditionDTO();
      this.condition.relationalOperator = null;
      this.contextVariable = '';
      this.output = new DialogOutputDTO({ type: MAP_OUTPUT_FROM_WATSON.TEXT }, true);
    }
  }

  static buildList(slots) {
    if (!slots) return;
    return slots.map((slot) => new DialogSlotsDTO(slot));
  }

  static validate = (slot) => {
    if (!slot.contextVariable || slot.contextVariable.trim() === '') return false;
    if (!slot.output) return false;
    if (!slot.output.values) return false;
    if (slot.output.values.length === 0) return false;
    if (slot.output.values[0].trim() === '') return false;

    const condition = slot.condition;
    if (!DialogConditionDTO.validate(condition)) {
      return false;
    }

    return true;
  }

  static parseList = (slots) => {
    if (!slots) return null;
    const ret = [];

    slots.forEach((slot) => {
      const condition = DialogConditionDTO.parseList([slot.condition]);
      const context = {
        [slot.contextVariable]: condition,
      };
      ret.push({
        context,
        outputs: [slot.output],
      });
    });

    return ret;
  }
}
